import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import Pagination from "@mui/material/Pagination";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MenuSelecter from "components/MenuSelecter";
import { useDispatch, useSelector } from "react-redux";

import MDTypography from "components/MDTypography";
import {
  Button,
  Checkbox,
  Collapse,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Delete,
  Input,
  KeyboardArrowDownRounded,
  KeyboardArrowUpRounded,
  RestartAlt,
  Search,
  Clear,
} from "@mui/icons-material";

import Switch from "@mui/material/Switch";
import { Edit, Visibility, VisibilityOff } from "@mui/icons-material";
import { useMaterialUIController } from "context";
import DataTable from "examples/Tables/DataTable";
import { getAllProducts } from "redux/festures/productSlice";
import { useEffect, useState } from "react";
import SkLoading from "components/SkLoading";
import SkConfirm from "components/SkComfirm";
import MDBadge from "components/MDBadge";
import { updateProducts } from "redux/festures/productSlice";
import { handleAlert } from "redux/festures/alertSlice";
import { getSingleProduct } from "redux/festures/productSlice";
import { getSingleReview } from "redux/festures/reviewSlice";
import { getAllGlobalProducts } from "redux/festures/productSlice";
import MDInput from "components/MDInput";
import { useLocation } from "react-router-dom";
import { getProductsWithoutLoading } from "redux/festures/productSlice";
import http from "Utils/api2";
import { getAllCity } from "redux/festures/citySlice";

export default function BasicTabs({
  setUpdateProduct,
  setCreateProduct,
  setGetUrl,
  setCreateLens,
  unShow,
  setViewData,
  setViewContactModal,
  setViewProductModal,
  setViewProductId,
  isPages,
  setIsPages,
  isSwitch,
  setIsSwitch,
  isOpen,
  setIsOpen,
  setUpdateProductModal,
  setProductId,
}) {
  const dispatch = useDispatch();
  const admin = localStorage.getItem("admin_id");
  const { pathname } = useLocation();

  const { AllProducts, Loading, page } = useSelector((state) => state.isProducts) || {};
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [value, setValue] = useState(0);
  const [isFilterName, setIsFilterName] = useState("name");
  const [isSort, setIsSort] = useState("Sort By");
  const [isSearch, setIsSearch] = useState("");

  //filter states

  const [filterCollapse, setFilterCollapse] = useState(false);
  const [AllCategory, setAllCategory] = useState([]);
  const [AllSubCategory, setAllSubCategory] = useState([]);
  const [AllTax, setAllTax] = useState([]);
  const { city } = useSelector((state) => state.isCity);

  const [rowsData, setRowsData] = useState([]);

  const [current, setcurrent] = useState(null);

  //Static Filters

  const dateFilter = [
    {
      _id: 0,
      name: "All Products",
    },
    {
      _id: "today",
      name: "Today",
    },
    {
      _id: "week",
      name: "This Week",
    },
    {
      _id: "month",
      name: "This Month",
    },
    {
      _id: "year",
      name: "This Year",
    },
    // {
    //   _id: 'manually',
    //   name: 'Manually'
    // },
  ];

  const sortByPrice = [
    {
      _id: 0,
      name: "All",
    },
    {
      _id: "high_to_low",
      name: "High To Low",
    },
    {
      _id: "low_to_high",
      name: "Low To High",
    },
  ];

  const isDisableFilter = [
    {
      _id: 0,
      name: "All",
    },
    {
      _id: false,
      name: "Active",
    },
    {
      _id: true,
      name: "Disabled",
    },
  ];

  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [isBulkDeleteOpen, setIsBulkDeleteOpen] = useState(false);
  const [bulkDeleting, setBulkDeleting] = useState(false);
  const [singleDeleteDialog, setSingleDeleteDialog] = useState({
    open: false,
    id: null,
    title: "",
    isRestore: false,
    isEcom: false,
  });
  const [singleDeleting, setSingleDeleting] = useState(false);

  const currentPageIds = (AllProducts || []).map((p) => p._id);
  const isAllSelected =
    currentPageIds.length > 0 && currentPageIds.every((id) => selectedProductIds.includes(id));
  const isSomeSelected =
    !isAllSelected && currentPageIds.some((id) => selectedProductIds.includes(id));

  const selectColumnHeader = (
    <Checkbox
      checked={isAllSelected}
      indeterminate={isSomeSelected}
      onChange={(e) => {
        if (e.target.checked) {
          setSelectedProductIds((prev) => Array.from(new Set([...prev, ...currentPageIds])));
        } else {
          setSelectedProductIds((prev) => prev.filter((id) => !currentPageIds.includes(id)));
        }
      }}
      sx={({ palette: { dark, white } }) => ({
        color: darkMode ? white?.main : dark?.main,
        "&.Mui-checked": {
          color: darkMode ? white?.main : dark?.main,
        },
      })}
    />
  );

  const columns = {
    service: {
      name: "Service Products",
      value: "service",
      pagination: true,
      col: [
        { Header: selectColumnHeader, accessor: "select" },
        { Header: "S.No", accessor: "no" },
        { Header: "Thumbnail", accessor: "thumbnail" },
        { Header: "Title", accessor: "title" },
        { Header: "Price", accessor: "price" },
        { Header: "MRP", accessor: "mrp" },

        { Header: "Category", accessor: "category" },

        { Header: "delete", accessor: "delete" },

        { Header: "View", accessor: "view" },
        { Header: "Action", accessor: "action" },
      ],
    },
    ecomm: {
      name: "Ecommerce Products",
      value: "ecomm",
      pagination: true,
      col: [
        { Header: selectColumnHeader, accessor: "select" },
        { Header: "S.No", accessor: "no" },
        { Header: "Thumbnail", accessor: "thumbnail" },
        { Header: "Title", accessor: "title" },
        { Header: "Price / MRP", accessor: "price/mrp" },

        { Header: "Category", accessor: "category" },
        { Header: "Stock", accessor: "stock" },

        { Header: "delete", accessor: "delete" },
        { Header: "View", accessor: "view" },
        { Header: "Action", accessor: "action" },
      ],
    },
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [pcategoryId, setPcategoryId] = useState(0);
  const [subcategoryId, setSubcategoryId] = useState(0);
  const [filter, setFilter] = useState(0);
  const [price, setprice] = useState(0);
  const [taxId, setTaxId] = useState(0);
  const [disable, setDisable] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const handleBulkDeleteConfirm = async () => {
    if (!selectedProductIds || selectedProductIds.length === 0) return;
    setBulkDeleting(true);
    try {
      const url =
        current?.value === "ecomm"
          ? `${process.env.REACT_APP_API}/eCommerce/bulkDeleteProducts/${admin}`
          : `${process.env.REACT_APP_API}/bulkDeleteProducts/${admin}`;

      const response = await http.post(url, { productIds: selectedProductIds });
      dispatch(
        handleAlert({
          isOpen: true,
          type: response?.data?.success ? "success" : "error",
          msg: response?.data?.message || "Products deleted successfully",
        })
      );
      setSelectedProductIds([]);
      setIsBulkDeleteOpen(false);
      if (setIsSwitch) setIsSwitch((prev) => !prev);
    } catch (error) {
      dispatch(
        handleAlert({
          isOpen: true,
          type: "error",
          msg: error?.response?.data?.message || "Failed to delete products",
        })
      );
    } finally {
      setBulkDeleting(false);
    }
  };

  const handleSingleDeleteConfirm = () => {
    if (!singleDeleteDialog.id) return;
    setSingleDeleting(true);
    const { id, isEcom } = singleDeleteDialog;
    const url = isEcom
      ? `${process.env.REACT_APP_APII}/eCommerce/disableProduct/${id}/${admin}`
      : `${process.env.REACT_APP_APII}/disableProduct/${id}/${admin}`;

    dispatch(updateProducts({ url })).then((data) => {
      setSingleDeleting(false);
      setSingleDeleteDialog({
        open: false,
        id: null,
        title: "",
        isRestore: false,
        isEcom: false,
      });
      dispatch(
        handleAlert({
          isOpen: true,
          type: `${data?.payload?.success ? "success" : "error"}`,
          msg: data?.payload?.message,
        })
      );
      if (data?.payload?.success) {
        if (AllProducts && AllProducts.length === 1 && isPages > 1) {
          setIsPages((prev) => prev - 1);
        } else if (setIsSwitch) {
          setIsSwitch((prev) => !prev);
        } else {
          const encodedSearch = debouncedSearch ? encodeURIComponent(debouncedSearch.trim()) : "";
          const query = `${pcategoryId ? `&pcategoryId=${pcategoryId}` : ""}${
            subcategoryId ? `&subcategoryId=${subcategoryId}` : ""
          }${filter ? `&filter=${filter}` : ""}${price ? `&price=${price}` : ""}${
            taxId ? `&taxId=${taxId}` : ""
          }${`&disable=${
            disable === 0 ? "" : disable === false ? false : disable === "na" ? "na" : true
          }`}${encodedSearch ? `&search=${encodedSearch}` : ""}${isPages ? `&page=${isPages}` : ""}`;
          const queryString = query.startsWith("&") ? query.slice(1) : query;

          const fetchUrl = isEcom
            ? `${process.env.REACT_APP_APII}/eCommerce/filterProductByDate/${admin}?${queryString}`
            : `${process.env.REACT_APP_APII}/filterProductByDate/${admin}?${queryString}`;

          dispatch(getAllGlobalProducts(fetchUrl));
        }
      }
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 350);
    return () => clearTimeout(timer);
  }, [search]);

  const handleResetFilters = () => {
    setSearch("");
    setDebouncedSearch("");
    setPcategoryId(0);
    setSubcategoryId(0);
    setAllSubCategory([]);
    setFilter(0);
    setprice(0);
    setTaxId(0);
    setDisable(false);
    setIsPages(1);
    setFilterCollapse(false);
    setSelectedProductIds([]);
  };

  useEffect(() => {
    if (pathname === "/products/ecom-products") setcurrent(columns?.ecomm);
    else setcurrent(columns?.service);
  }, [pathname, selectedProductIds, AllProducts, darkMode]);

  useEffect(() => {
    // Reset filters and close collapsible filter dropdowns when switching pages
    setFilterCollapse(false);
    setPcategoryId(0);
    setSubcategoryId(0);
    setAllSubCategory([]);
    setFilter(0);
    setprice(0);
    setTaxId(0);
    setSearch("");
    setDebouncedSearch("");
    setDisable(false);
    setIsPages(1);
    setSelectedProductIds([]);
  }, [pathname]);

  useEffect(() => {
    if (current?.value === "service") {
      dispatch(getAllCity(`/getAllCityByAdmin/${admin}`));
    }

    if (current?.value === "service" || current?.value === "ecomm")
      http
        .get(
          current?.value !== "service"
            ? `/eCommerce/getAllCategoryWithPcategory/${admin}?disable=false`
            : `/getAllCategoryWithPcategory/${admin}?disable=false`
        )
        .then((response) => {
          setAllCategory(response?.data?.data || []);
        })
        .catch((error) => {
          dispatch(
            handleAlert({
              isOpen: true,
              type: "error",
              msg: error?.response?.data?.message,
            })
          );
        });

    http
      .get(`/getAllTax/${admin}`)
      .then((response) => {
        const tax =
          response?.data?.data && response?.data?.data?.length
            ? [...response?.data?.data]?.map((ele) => {
                const temp = { ...ele };
                temp.taxPercent = `${temp.taxPercent} %`;
                return temp;
              })
            : [];
        setAllTax(tax);
      })
      .catch((error) => {
        dispatch(
          handleAlert({
            isOpen: true,
            type: "error",
            msg: error?.response?.data?.message,
          })
        );
      });
  }, [current?.value]);

  useEffect(() => {
    if (pcategoryId) {
      http
        .get(
          current?.value !== "service"
            ? `/eCommerce/getCategoryWithPcategory/${pcategoryId}/${admin}?disable=false`
            : `/getCategoryWithPcategory/${pcategoryId}/${admin}?disable=false`
        )
        .then((response) => {
          setAllSubCategory(response?.data?.data || []);
        })
        .catch((error) => {
          dispatch(
            handleAlert({
              isOpen: true,
              type: "error",
              msg: error?.response?.data?.message,
            })
          );
        });
    } else {
      setAllSubCategory([]);
      setSubcategoryId(0);
    }
  }, [pcategoryId, current?.value]);

  useEffect(() => {
    const encodedSearch = debouncedSearch ? encodeURIComponent(debouncedSearch.trim()) : "";
    const query = `${pcategoryId ? `&pcategoryId=${pcategoryId}` : ""}${
      subcategoryId ? `&subcategoryId=${subcategoryId}` : ""
    }${filter ? `&filter=${filter}` : ""}${price ? `&price=${price}` : ""}${
      taxId ? `&taxId=${taxId}` : ""
    }${`&disable=${
      disable === 0 ? "" : disable === false ? false : disable === "na" ? "na" : true
    }`}${encodedSearch ? `&search=${encodedSearch}` : ""}${isPages ? `&page=${isPages}` : ""}`;

    const queryString = query.startsWith("&") ? query.slice(1) : query;

    if (current?.value === "service") {
      dispatch(
        getAllGlobalProducts(
          `/filterProductByDate/${admin}?${queryString}`
        )
      );
    } else if (current?.value === "ecomm") {
      dispatch(
        getAllGlobalProducts(
          `/eCommerce/filterProductByDate/${admin}?${queryString}`
        )
      );
    }
  }, [isPages, pcategoryId, subcategoryId, filter, price, taxId, disable, debouncedSearch, current?.value, isSwitch]);

  useEffect(() => {
    if (current?.value === "service") {
      setRowsData(
        AllProducts && AllProducts?.length
          ? AllProducts?.map((value, index) => ({
              select: (
                <Checkbox
                  checked={selectedProductIds.includes(value?._id)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedProductIds((prev) => [...prev, value?._id]);
                    } else {
                      setSelectedProductIds((prev) => prev.filter((id) => id !== value?._id));
                    }
                  }}
                  sx={({ palette: { dark, white } }) => ({
                    color: darkMode ? white?.main : dark?.main,
                    "&.Mui-checked": {
                      color: darkMode ? white?.main : dark?.main,
                    },
                  })}
                />
              ),
              no: (
                <MDTypography sx={{ fontSize: 12, fontWeight: "medium" }} variant="text">
                  {index + 1}
                </MDTypography>
              ),
              thumbnail: (
                <MDBox
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: 0.5,
                  }}
                >
                  <MDBox sx={{ height: 40, width: 40 }}>
                    <img
                      src={`${process.env.REACT_APP_URI}/${value?.thumnail}`}
                      alt={"img"}
                      onError={(e) => {
                        (e.onError = null),
                          (e.target.src = require("../../../assets/images/bg-profile.png"));
                      }}
                      style={{ width: "100%", height: "100%", borderRadius: "50%" }}
                    />
                  </MDBox>
                </MDBox>
              ),
              title: (
                <MDBox
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: 0.5,
                    flexDirection: "column",
                    // overflow: "hidden",
                    // textOverflow: "ellipsis",
                  }}
                >
                  <MDTypography
                    display="block"
                    variant="button"
                    fontWeight="medium"
                    ml={1}
                    lineHeight={1}
                    style={{
                      maxWidth: "250px",
                      lineHeight: "20px",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Name: {value?.title || "-"}
                  </MDTypography>

                  <MDTypography
                    display="block"
                    variant="button"
                    fontWeight="medium"
                    ml={1}
                    lineHeight={1}
                    fontSize={14}
                  >
                    ProductId: {value?._id || "-"}
                  </MDTypography>
                </MDBox>
              ),
              price: (
                <MDTypography
                  display="block"
                  variant="button"
                  fontWeight="medium"
                  ml={1}
                  lineHeight={1}
                >
                  {value?.price.toLocaleString("en-US", {
                    style: "currency",
                    currency: "INR",
                  }) || "-"}
                </MDTypography>
              ),
              mrp: (
                <MDTypography
                  display="block"
                  variant="button"
                  fontWeight="medium"
                  ml={1}
                  lineHeight={1}
                >
                  {value?.mrp.toLocaleString("en-US", {
                    style: "currency",
                    currency: "INR",
                  }) || "-"}
                </MDTypography>
              ),
              category: (
                <MDTypography
                  display="block"
                  variant="button"
                  fontWeight="medium"
                  ml={1}
                  lineHeight={1}
                  style={{
                    maxWidth: "250px",
                    lineHeight: "20px",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: (!value?.categoryId || value?.categoryId?.disable) ? "#f44336" : "inherit",
                  }}
                >
                  {value?.categoryId?.name ? value?.categoryId?.name : "N/A"}
                </MDTypography>
              ),
              view: (
                <IconButton
                  aria-label="action_edit"
                  onClick={() => {
                    setViewProductModal(true);
                    setViewProductId(value);
                  }}
                >
                  <Visibility
                    sx={({ palette: { dark, white, info } }) => ({
                      color: darkMode ? info.main : dark.main,
                    })}
                  />
                </IconButton>
              ),

              delete: (
                <Tooltip title={value?.disable ? "move to Active" : "delete"}>
                  <IconButton
                    aria-label="action_edit"
                    // disabled={value?.disable}
                    onClick={() => {
                      setSingleDeleteDialog({
                        open: true,
                        id: value?._id,
                        title: value?.title || "this service",
                        isRestore: Boolean(value?.disable),
                        isEcom: false,
                      });
                    }}
                  >
                    {value?.disable ? (
                      <Input
                        sx={({ palette: { dark, white, info } }) => ({
                          color: darkMode ? info.main : dark.main,
                        })}
                      />
                    ) : (
                      <Delete
                        sx={({ palette: { dark, white, info } }) => ({
                          color: darkMode ? info.main : dark.main,
                        })}
                      />
                    )}
                  </IconButton>
                </Tooltip>
              ),
              action: (
                <IconButton
                  aria-label="action_edit"
                  onClick={() => {
                    setIsOpen(true);
                    setUpdateProductModal(true);
                    // console.log(value?._id);
                    dispatch(getSingleProduct(value));
                  }}
                >
                  <Edit
                    sx={({ palette: { dark, white, info } }) => ({
                      color: darkMode ? info.main : dark.main,
                    })}
                  />
                </IconButton>
              ),
            }))
          : null
      );
    } else if (current?.value === "ecomm") {
      const temprows =
        AllProducts &&
        AllProducts?.length &&
        AllProducts?.map((value, index) => ({
          select: (
            <Checkbox
              checked={selectedProductIds.includes(value?._id)}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedProductIds((prev) => [...prev, value?._id]);
                } else {
                  setSelectedProductIds((prev) => prev.filter((id) => id !== value?._id));
                }
              }}
              sx={({ palette: { dark, white } }) => ({
                color: darkMode ? white?.main : dark?.main,
                "&.Mui-checked": {
                  color: darkMode ? white?.main : dark?.main,
                },
              })}
            />
          ),
          no: (
            <MDTypography sx={{ fontSize: 12, fontWeight: "medium" }} variant="text">
              {index + 1}
            </MDTypography>
          ),
          thumbnail: (
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: 0.5,
              }}
            >
              <MDBox sx={{ height: 40, width: 40 }}>
                <img
                  src={`${process.env.REACT_APP_URI}/${value?.thumnail}`}
                  alt={"img"}
                  onError={(e) => {
                    (e.onError = null),
                      (e.target.src = require("../../../assets/images/bg-profile.png"));
                  }}
                  style={{ width: "100%", height: "100%", borderRadius: "50%" }}
                />
              </MDBox>
            </MDBox>
          ),

          title: (
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: 0.5,
                flexDirection: "column",
                // maxWidth: '10rem',
                overflow: "hidden",
                // textOverflow: "ellipsis",
              }}
            >
              <MDTypography
                display="block"
                variant="button"
                fontWeight="medium"
                ml={1}
                lineHeight={1}
                style={{
                  maxWidth: "250px",
                  lineHeight: "20px",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 2,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Name: {value?.title || "-"}
              </MDTypography>

              <MDTypography
                display="block"
                variant="button"
                fontWeight="medium"
                ml={1}
                lineHeight={1}
                fontSize={14}
              >
                ProductId: {value?._id || "-"}
              </MDTypography>
            </MDBox>
          ),
          "price/mrp": (
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: 0.5,
                flexDirection: "column",
                // overflow: "hidden",
                // textOverflow: "ellipsis",
              }}
            >
              <MDTypography
                display="block"
                variant="button"
                fontWeight="medium"
                ml={1}
                lineHeight={1}
              >
                {value?.price.toLocaleString("en-US", {
                  style: "currency",
                  currency: "INR",
                }) || "-"}
              </MDTypography>
              <MDTypography
                display="block"
                variant="button"
                fontWeight="medium"
                ml={1}
                lineHeight={1}
                fontSize={10}
              >
                /
                {value?.mrp.toLocaleString("en-US", {
                  style: "currency",
                  currency: "INR",
                }) || "-"}
              </MDTypography>
            </MDBox>
          ),
          time: (
            <MDTypography
              display="block"
              variant="button"
              fontWeight="medium"
              ml={1}
              lineHeight={1}
            >
              {value?.time || "-"} Minutes
            </MDTypography>
          ),
          category: (
            <MDTypography
              display="block"
              variant="button"
              fontWeight="medium"
              ml={1}
              lineHeight={1}
              style={{
                maxWidth: "250px",
                lineHeight: "20px",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: (!value?.categoryId || value?.categoryId?.disable) ? "#f44336" : "inherit",
              }}
            >
              {value?.categoryId?.name ? value?.categoryId?.name : "N/A"}
            </MDTypography>
          ),
          stock: (
            <MDTypography
              display="block"
              variant="button"
              fontWeight="medium"
              ml={1}
              lineHeight={1}
            >
              {value?.stock || "0"}
            </MDTypography>
          ),
          view: (
            <IconButton
              aria-label="action_edit"
              onClick={() => {
                setViewProductModal(true);
                setViewProductId(value);
              }}
            >
              <Visibility
                sx={({ palette: { dark, white, info } }) => ({
                  color: darkMode ? info.main : dark.main,
                })}
              />
            </IconButton>
          ),

          delete: (
            <Tooltip title={value?.disable ? "move to Active" : "delete"}>
              <IconButton
                aria-label="action_edit"
                // disabled={value?.disable}
                onClick={() => {
                  setSingleDeleteDialog({
                    open: true,
                    id: value?._id,
                    title: value?.title || "this product",
                    isRestore: Boolean(value?.disable),
                    isEcom: true,
                  });
                }}
              >
                {value?.disable ? (
                  <Input
                    sx={({ palette: { dark, white, info } }) => ({
                      color: darkMode ? info.main : dark.main,
                    })}
                  />
                ) : (
                  <Delete
                    sx={({ palette: { dark, white, info } }) => ({
                      color: darkMode ? info.main : dark.main,
                    })}
                  />
                )}
              </IconButton>
            </Tooltip>
          ),
          action: (
            <IconButton
              aria-label="action_edit"
              onClick={() => {
                setIsOpen(true);
                setUpdateProductModal(true);
                // console.log(value?._id);
                dispatch(getSingleProduct(value));
              }}
            >
              <Edit
                sx={({ palette: { dark, white, info } }) => ({
                  color: darkMode ? info.main : dark.main,
                })}
              />
            </IconButton>
          ),
        }));
      setRowsData(temprows);
    }
  }, [AllProducts, current?.value, selectedProductIds, darkMode]);

  return (
    <MDBox sx={{ width: "100%" }}>
      {/* Filter Section Header: Search on Left, Visibility on Right */}
      <MDBox
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          gap: 2,
          width: "100%",
          px: 3,
          pt: 3,
          pb: 1,
          flexWrap: { xs: "wrap", sm: "nowrap" },
        }}
      >
        {/* Left: Service Filter (Search box + toggle arrow) */}
        <MDBox
          sx={{
            width: { xs: "100%", sm: "320px" },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <MDTypography variant="button" sx={{ whiteSpace: "nowrap", mb: 0.5, fontWeight: "medium" }}>
            {current?.value === "ecomm" ? "Product Filter" : "Service Filter"}
          </MDTypography>
          <MDInput
            disabled={Loading}
            placeholder="Name, Include, Exclude, Id..."
            type="text"
            fullWidth
            name="search"
            value={search}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                setDebouncedSearch(search);
                setIsPages(1);
                if (setIsSwitch) setIsSwitch((prev) => !prev);
              }
            }}
            InputProps={{
              sx: { height: "44px" },
              startAdornment: (
                <InputAdornment position="start">
                  <IconButton
                    size="small"
                    title="Search"
                    onClick={() => {
                      setDebouncedSearch(search);
                      setIsPages(1);
                      if (setIsSwitch) setIsSwitch((prev) => !prev);
                    }}
                    sx={({ palette: { dark, white, info } }) => ({
                      color: darkMode ? white.main : dark.main,
                      p: 0.5,
                      "&:hover": {
                        color: info.main,
                      },
                    })}
                  >
                    <Search fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  {search && (
                    <IconButton
                      size="small"
                      title="Clear search"
                      onClick={() => {
                        setSearch("");
                        setDebouncedSearch("");
                        setIsPages(1);
                        if (setIsSwitch) setIsSwitch((prev) => !prev);
                      }}
                      sx={{ p: 0.5, mr: 0.5, opacity: 0.7, "&:hover": { opacity: 1 } }}
                    >
                      <Clear fontSize="small" />
                    </IconButton>
                  )}
                  <IconButton
                    size="small"
                    onClick={() => setFilterCollapse(!filterCollapse)}
                    sx={({ palette: { dark, white } }) => ({
                      backgroundColor: darkMode ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.05)",
                      borderRadius: "4px",
                      p: 0.5,
                      color: darkMode ? white.main : dark.main,
                      "&:hover": {
                        backgroundColor: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.1)",
                      },
                    })}
                  >
                    {filterCollapse ? (
                      <KeyboardArrowUpRounded fontSize="small" />
                    ) : (
                      <KeyboardArrowDownRounded fontSize="small" />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            onChange={(e) => {
              if (current?.value === "service" || current?.value === "ecomm") {
                setIsPages(1);
                setSearch(e.target.value);
              }
            }}
          />
        </MDBox>

        {/* Right side controls: Visibility Filter + Reset Button */}
        <MDBox
          sx={{
            display: "flex",
            alignItems: "flex-end",
            gap: 1.5,
            flexWrap: { xs: "wrap", sm: "nowrap" },
          }}
        >
          <MDBox
            sx={{
              width: { xs: "100%", sm: "200px" },
              minWidth: "160px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="button" sx={{ whiteSpace: "nowrap", mb: 0.5, fontWeight: "medium" }}>
              Filter By Visibility
            </MDTypography>
            <Select
              disabled={Loading}
              value={disable}
              onChange={(e) => {
                setIsPages(1);
                setDisable(e.target.value);
              }}
              sx={({ palette: { dark, white } }) => ({
                width: "100%",
                height: "44px",
                color: darkMode ? white?.main : dark?.main,
                bgcolor: "transparent",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: darkMode ? "rgba(255, 255, 255, 0.3) !important" : "rgba(0, 0, 0, 0.23) !important",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: darkMode ? "rgba(255, 255, 255, 0.6) !important" : "rgba(0, 0, 0, 0.5) !important",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2196f3 !important",
                },
                "& .MuiSelect-icon": {
                  color: darkMode ? white?.main : dark?.main,
                  display: "block !important",
                  fontSize: "1.5rem !important",
                },
              })}
            >
              {isDisableFilter?.map((ele, i) => (
                <MenuItem key={i} value={ele?._id}>
                  {ele?.name}
                </MenuItem>
              ))}
            </Select>
          </MDBox>

          {selectedProductIds.length > 0 && (
            <MDButton
              variant="gradient"
              color="error"
              onClick={() => setIsBulkDeleteOpen(true)}
              disabled={Loading || bulkDeleting}
              sx={{
                height: "44px",
                px: 2,
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                whiteSpace: "nowrap",
                textTransform: "none",
                fontSize: "0.875rem",
                fontWeight: "medium",
              }}
            >
              <Delete fontSize="small" />
              Delete Selected ({selectedProductIds.length})
            </MDButton>
          )}

          <MDButton
            variant="gradient"
            color="error"
            onClick={handleResetFilters}
            disabled={Loading}
            sx={{
              height: "44px",
              px: 2,
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              whiteSpace: "nowrap",
              textTransform: "none",
              fontSize: "0.875rem",
              fontWeight: "medium",
            }}
          >
            <RestartAlt fontSize="small" />
            Reset
          </MDButton>
        </MDBox>
      </MDBox>

      {/* Collapsible Second Row: 5 Filters */}
      <Collapse in={filterCollapse} timeout="auto" unmountOnExit sx={{ width: "100%", px: 3, pb: 2 }}>
        <MDBox
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: "repeat(5, 1fr)",
            },
            gap: 2,
            width: "100%",
            pt: 1,
          }}
        >
          {/* Filter 1: Duration */}
          <MDBox sx={{ display: "flex", flexDirection: "column" }}>
            <MDTypography variant="button" sx={{ whiteSpace: "nowrap", mb: 0.5, fontWeight: "medium" }}>
              Filter By Duration
            </MDTypography>
            <Select
              disabled={Loading}
              value={filter}
              onChange={(e) => {
                setIsPages(1);
                setFilter(e.target.value);
              }}
              sx={({ palette: { dark, white } }) => ({
                width: "100%",
                height: "44px",
                color: darkMode ? white?.main : dark?.main,
                bgcolor: "transparent",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: darkMode ? "rgba(255, 255, 255, 0.3) !important" : "rgba(0, 0, 0, 0.23) !important",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: darkMode ? "rgba(255, 255, 255, 0.6) !important" : "rgba(0, 0, 0, 0.5) !important",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2196f3 !important",
                },
                "& .MuiSelect-icon": {
                  color: darkMode ? white?.main : dark?.main,
                  display: "block !important",
                  fontSize: "1.5rem !important",
                },
              })}
            >
              {dateFilter?.map((ele, i) => (
                <MenuItem key={i} value={ele?._id}>
                  {ele?.name}
                </MenuItem>
              ))}
            </Select>
          </MDBox>

          {/* Filter 2: Category */}
          <MDBox sx={{ display: "flex", flexDirection: "column" }}>
            <MDTypography variant="button" sx={{ whiteSpace: "nowrap", mb: 0.5, fontWeight: "medium" }}>
              Filter By Category
            </MDTypography>
            <Select
              disabled={Loading}
              value={pcategoryId}
              onChange={(e) => {
                setIsPages(1);
                setPcategoryId(e.target.value);
                setSubcategoryId(0);
              }}
              sx={({ palette: { dark, white } }) => ({
                width: "100%",
                height: "44px",
                color: darkMode ? white?.main : dark?.main,
                bgcolor: "transparent",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: darkMode ? "rgba(255, 255, 255, 0.3) !important" : "rgba(0, 0, 0, 0.23) !important",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: darkMode ? "rgba(255, 255, 255, 0.6) !important" : "rgba(0, 0, 0, 0.5) !important",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2196f3 !important",
                },
                "& .MuiSelect-icon": {
                  color: darkMode ? white?.main : dark?.main,
                  display: "block !important",
                  fontSize: "1.5rem !important",
                },
              })}
            >
              <MenuItem value={0}>Choose Category</MenuItem>
              {AllCategory?.map((ele, i) => (
                <MenuItem key={i} value={ele?._id}>
                  {ele?.name}
                </MenuItem>
              ))}
            </Select>
          </MDBox>

          {/* Filter 3: Sub Category */}
          <MDBox sx={{ display: "flex", flexDirection: "column" }}>
            <MDTypography variant="button" sx={{ whiteSpace: "nowrap", mb: 0.5, fontWeight: "medium" }}>
              Filter By Sub Category
            </MDTypography>
            <Select
              disabled={Loading}
              value={subcategoryId}
              onChange={(e) => {
                setIsPages(1);
                setSubcategoryId(e.target.value);
              }}
              sx={({ palette: { dark, white } }) => ({
                width: "100%",
                height: "44px",
                color: darkMode ? white?.main : dark?.main,
                bgcolor: "transparent",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: darkMode ? "rgba(255, 255, 255, 0.3) !important" : "rgba(0, 0, 0, 0.23) !important",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: darkMode ? "rgba(255, 255, 255, 0.6) !important" : "rgba(0, 0, 0, 0.5) !important",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2196f3 !important",
                },
                "& .MuiSelect-icon": {
                  color: darkMode ? white?.main : dark?.main,
                  display: "block !important",
                  fontSize: "1.5rem !important",
                },
              })}
            >
              <MenuItem value={0}>{pcategoryId ? "Choose Sub Category" : "Select Category First"}</MenuItem>
              {AllSubCategory?.map((ele, i) => (
                <MenuItem key={i} value={ele?._id}>
                  {ele?.name}
                </MenuItem>
              ))}
            </Select>
          </MDBox>

          {/* Filter 4: Price */}
          <MDBox sx={{ display: "flex", flexDirection: "column" }}>
            <MDTypography variant="button" sx={{ whiteSpace: "nowrap", mb: 0.5, fontWeight: "medium" }}>
              Sort By Price
            </MDTypography>
            <Select
              disabled={Loading}
              value={price}
              onChange={(e) => {
                setIsPages(1);
                setprice(e.target.value);
              }}
              sx={({ palette: { dark, white } }) => ({
                width: "100%",
                height: "44px",
                color: darkMode ? white?.main : dark?.main,
                bgcolor: "transparent",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: darkMode ? "rgba(255, 255, 255, 0.3) !important" : "rgba(0, 0, 0, 0.23) !important",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: darkMode ? "rgba(255, 255, 255, 0.6) !important" : "rgba(0, 0, 0, 0.5) !important",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2196f3 !important",
                },
                "& .MuiSelect-icon": {
                  color: darkMode ? white?.main : dark?.main,
                  display: "block !important",
                  fontSize: "1.5rem !important",
                },
              })}
            >
              {sortByPrice?.map((ele, i) => (
                <MenuItem key={i} value={ele?._id}>
                  {ele?.name}
                </MenuItem>
              ))}
            </Select>
          </MDBox>

          {/* Filter 5: Tax */}
          <MDBox sx={{ display: "flex", flexDirection: "column" }}>
            <MDTypography variant="button" sx={{ whiteSpace: "nowrap", mb: 0.5, fontWeight: "medium" }}>
              Filter By Tax
            </MDTypography>
            <Select
              disabled={Loading}
              value={taxId}
              onChange={(e) => {
                setIsPages(1);
                setTaxId(e.target.value);
              }}
              sx={({ palette: { dark, white } }) => ({
                width: "100%",
                height: "44px",
                color: darkMode ? white?.main : dark?.main,
                bgcolor: "transparent",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: darkMode ? "rgba(255, 255, 255, 0.3) !important" : "rgba(0, 0, 0, 0.23) !important",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: darkMode ? "rgba(255, 255, 255, 0.6) !important" : "rgba(0, 0, 0, 0.5) !important",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2196f3 !important",
                },
                "& .MuiSelect-icon": {
                  color: darkMode ? white?.main : dark?.main,
                  display: "block !important",
                  fontSize: "1.5rem !important",
                },
              })}
            >
              <MenuItem value={0}>Choose Tax Slab</MenuItem>
              {AllTax?.map((ele, i) => (
                <MenuItem key={i} value={ele?._id}>
                  {ele?.taxPercent}
                </MenuItem>
              ))}
            </Select>
          </MDBox>
        </MDBox>
      </Collapse>

      {Loading ? (
        <SkLoading />
      ) : (
        // tabsName.map((elm, i) => {
        //   return (
        //     <>
        //       <TabPanel value={value} index={i}>
        //         {/* <ProductsTable
        //         columns={current.col}
        //         rows={rows}
        //         current={current}
        //         currentFilter={currentFilter}
        //         setCurrentFilter={setCurrentFilter}
        //         filters={filters}
        //         filterInput={filterInput}
        //         setFilterInput={setFilterInput}
        //       /> */}
        //         {AllProducts && AllProducts.length > 0 ? (
        //           <DataTable
        //             table={{
        //               columns: current.col,
        //               rows: rowsData,
        //             }}
        //             isSorted={false}
        //             entriesPerPage={false}
        //             isPages={AllProducts && AllProducts.length}
        //             noEndBorder
        //             canSearch={false}
        //             showTotalEntries={false}
        //             pagination={false}
        //             isPagination={false}
        //           />
        //         ) : (
        //           <MDBox
        //             // key={index}
        //             display="flex"
        //             justifyContent="center"
        //             gap={2}
        //             alignItems="center"
        //           // width={"100%"}
        //           >
        //             <MDTypography variant="h6">Something went wrong !</MDTypography>
        //           </MDBox>
        //         )}
        //         {current.pagination ? (
        //           <MDBox className="center" py={3}>
        //             {/* <Pagination
        //             count={totalPage}
        //             page={filterPage}
        //             onChange={handlePageChange}
        //             variant="outlined"
        //             color="primary"
        //           /> */}
        //           </MDBox>
        //         ) : null}
        //       </TabPanel>
        //     </>
        //   );
        // })
        <>
          {current && AllProducts && AllProducts.length > 0 ? (
            <DataTable
              table={{
                columns: current?.col,
                rows: rowsData || [],
              }}
              isSorted={false}
              entriesPerPage={false}
              isPages={AllProducts && AllProducts.length}
              noEndBorder
              canSearch={false}
              showTotalEntries={false}
              pagination={false}
              isPagination={false}
            />
          ) : (
            <MDBox
              // key={index}
              display="flex"
              justifyContent="center"
              gap={2}
              alignItems="center"
              // width={"100%"}
            >
              <MDTypography variant="h5"> Product Not Found ...!</MDTypography>
            </MDBox>
          )}
          {current?.pagination ? (
            <MDBox className="center" py={3}>
              {/* <Pagination
                    count={totalPage}
                    page={filterPage}
                    onChange={handlePageChange}
                    variant="outlined"
                    color="primary"
                  /> */}
            </MDBox>
          ) : null}
        </>
      )}

      {/* Confirmation Dialog for Bulk Deletion */}
      <SkConfirm
        dialogTitle="Confirm Delete"
        dialogContent={`Are you sure you want to delete ${selectedProductIds.length} selected product(s)?`}
        open={isBulkDeleteOpen}
        setOpen={setIsBulkDeleteOpen}
        rate={false}
        dialogAction={
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 3,
              px: 3,
            }}
          >
            <MDButton
              variant="gradient"
              color="info"
              sx={{ width: "50%" }}
              onClick={() => setIsBulkDeleteOpen(false)}
              disabled={bulkDeleting}
            >
              Cancel
            </MDButton>
            <MDButton
              variant="gradient"
              sx={{ width: "50%" }}
              color="error"
              onClick={handleBulkDeleteConfirm}
              disabled={bulkDeleting}
            >
              {bulkDeleting ? "Deleting..." : "Delete"}
            </MDButton>
          </MDBox>
        }
      />

      {/* Confirmation Dialog for Single Product Deletion / Restore */}
      <SkConfirm
        dialogTitle={singleDeleteDialog?.isRestore ? "Confirm Restore" : "Confirm Delete"}
        dialogContent={`Are you sure you want to ${
          singleDeleteDialog?.isRestore ? "restore" : "delete"
        } ${singleDeleteDialog?.title || "this product"}?`}
        open={singleDeleteDialog}
        setOpen={setSingleDeleteDialog}
        rate={singleDeleteDialog?.isRestore}
        dialogAction={
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 3,
              px: 3,
            }}
          >
            <MDButton
              variant="gradient"
              color="info"
              sx={{ width: "50%" }}
              onClick={() =>
                setSingleDeleteDialog((prev) => ({
                  ...prev,
                  open: false,
                  id: null,
                }))
              }
              disabled={singleDeleting}
            >
              Cancel
            </MDButton>
            <MDButton
              variant="gradient"
              sx={{ width: "50%" }}
              color={singleDeleteDialog?.isRestore ? "info" : "error"}
              onClick={handleSingleDeleteConfirm}
              disabled={singleDeleting}
            >
              {singleDeleting
                ? singleDeleteDialog?.isRestore
                  ? "Restoring..."
                  : "Deleting..."
                : singleDeleteDialog?.isRestore
                ? "Restore"
                : "Delete"}
            </MDButton>
          </MDBox>
        }
      />
    </MDBox>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

BasicTabs.propTypes = {
  //   children: PropTypes.node,
  setUpdateProduct: PropTypes.any,
  setCreateProduct: PropTypes.any,
  setGetUrl: PropTypes.any,
  setCreateLens: PropTypes.any,
  unShow: PropTypes.any,
  setViewData: PropTypes.any,
  setViewContactModal: PropTypes.any,
  setViewProductModal: PropTypes.any,
  setIsSwitch: PropTypes.any,
  isOpen: PropTypes.any,
  setIsOpen: PropTypes.any,
  setProductId: PropTypes.any,
  setUpdateProductModal: PropTypes.any,
  isSwitch: PropTypes.any,
  setIsPages: PropTypes.any,
  setViewProductId: PropTypes.string,
  isPages: PropTypes.number,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
